import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const RemovePaymentMethodModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "RemovePaymentMethodModalContainer" */
      './RemovePaymentMethodModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
